import React, {useId} from "react";

export default function Toggle({enabled, setEnabled, disabled}) {

    let id = useId();

    return <div className="form-switch">
        <input
            type="checkbox"
            id={id}
            className="sr-only"
            checked={enabled}
            onChange={() => setEnabled(!enabled)}
            disabled={disabled}
        />
        <label className="bg-slate-400 dark:bg-slate-700" htmlFor={id}>
            <span className="bg-white shadow-sm" aria-hidden="true"></span>
        </label>
    </div>;
}